<div class="info-empresa-page">
  <div class="container">
    <header class="page-header">
      <h1>Información de la empresa</h1>
    </header>

    <div class="content-section">
      <div class="image-container">
        <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
             alt="Equipo de profesionales de Unicard"
             class="company-image">
      </div>

      <div class="text-content">
        <p class="description-paragraph">
          Unicard S.A., es emisor de Tarjeta Unipay, instrumento que se puede emplear en la compra de bienes y servicios en todos los Supermercados Unimarc, Mayorista 10 y Alvi así como, obtener otros productos financieros tales como Avances y Súper Avances, de acuerdo a la evaluación y calificación previa.
        </p>

        <p class="description-paragraph">
          Unicard, es una empresa que busca satisfacer las necesidades de su cartera de Clientes, a través de soluciones financieras convenientes, fáciles de usar y simples.
        </p>
      </div>
    </div>
  </div>
</div>
